/**
 * First-party cookieless pageview beacon for the marketing film.
 * Posts to the Laravel portal — no PII, no cookies.
 * Optionally loads Google Analytics when configured in portal Settings.
 */

function portalBase() {
  const host = window.location.hostname;
  if (host === "127.0.0.1" || host === "localhost") {
    return window.__PORTAL_URL__ || "http://127.0.0.1:8001";
  }
  return "https://portal.divtodiv.com";
}

function sendPageviewBeacon() {
  const url = `${portalBase()}/api/t`;
  const payload = {
    path: window.location.pathname + window.location.search,
    referrer: document.referrer || "",
    viewport_w: window.innerWidth || 0,
  };

  // No credentials: the portal answers CORS with a wildcard, which browsers
  // reject for credentialed requests (sendBeacon always sends them).
  fetch(url, {
    method: "POST",
    headers: { Accept: "application/json", "Content-Type": "application/json" },
    body: JSON.stringify(payload),
    keepalive: true,
    mode: "cors",
    credentials: "omit",
  }).catch(() => {});
}

/** Pageview only — for pages that do not load third-party analytics. */
export function trackPageview() {
  sendPageviewBeacon();
}

function injectGoogleAnalytics(id) {
  if (!id || !/^G-[A-Z0-9]+$/i.test(id)) return;
  if (document.querySelector(`script[data-ga-id="${CSS.escape(id)}"]`)) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };

  window.gtag("js", new Date());
  window.gtag("config", id);

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
  script.dataset.gaId = id;
  document.head.appendChild(script);
}

function loadGoogleAnalyticsFromPortal() {
  fetch(`${portalBase()}/api/site`, {
    method: "GET",
    headers: { Accept: "application/json" },
    mode: "cors",
    credentials: "omit",
  })
    .then((res) => (res.ok ? res.json() : null))
    .then((data) => {
      const id = data?.google_analytics_id;
      if (typeof id === "string" && id) {
        injectGoogleAnalytics(id.trim());
      }
    })
    .catch(() => {});
}

export function initAnalytics() {
  const host = window.location.hostname;
  if (host === "127.0.0.1" || host === "localhost") {
    document.querySelectorAll(".footer-login").forEach((a) => {
      a.setAttribute("href", portalUrl("/login"));
    });
  }

  sendPageviewBeacon();

  const cachedId = window.__SITE_CONFIG__?.google_analytics_id;
  if (typeof cachedId === "string" && cachedId) {
    injectGoogleAnalytics(cachedId.trim());
    return;
  }

  loadGoogleAnalyticsFromPortal();
}

export function portalUrl(path = "") {
  return `${portalBase()}${path}`;
}
